var map = {
	"./finance tracker.png": 7459,
	"./hackoverflowv3.png": 8775,
	"./hospital dashboard.png": 9470,
	"./nextjs blog.png": 2467,
	"./rec iccds.png": 6032,
	"./rec ieee.png": 6671,
	"./recharge 24.png": 1358,
	"./sih.png": 757,
	"./social media bot.png": 401,
	"./student portal.png": 8288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2800;